module.exports = __webpack_public_path__ + "img/logo-110x40.64afcd61.png";